module.exports = __webpack_public_path__ + "static/media/step-1-form.0aa1506e.svg";